import {
  Button,
  Checkbox,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { DragIndicator, MoreHoriz, RemoveCircle, AddCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PublishIcon from '@mui/icons-material/Publish';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect } from 'react';
import {
  IN_ROOM_DINING_MENU_CREATE,
  IN_ROOM_DINING_MENU_EDIT_DRAWER,
  IN_ROOM_DINING_MENU_VIEW,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import { PARTIAL_CHECKBOX_GREEN, updateSelectedModule } from '../../../../../utils/formUtils';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { isEmpty } from 'lodash';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const InRoomDiningMenuListTable = (props) => {
  const {
    menuList,
    dragDisabled,
    page,
    rowsPerPage,
    handleCellMenuClick,
    selectedValue,
    handleClose,
    onClickRowViewDetails,
    onViewDetails,
    handleChangePage,
    handleChangeRowsPerPage,
    onActiveDeActiveMenuItem,
    onClickDeleteMenu,
    permissions,
    onOpenDrawer,
    setMenuList,
    setVisible,
    onClickEditDetails,
    handleSelectAll,
    isAllSelected,
    setIsAllSelected,
    handleCheckboxChange,
    setActionMenuList,
    selectedIRD_MENULength,
    inRoomDiningMenu,
    searchText,
  } = props;

  useEffect(() => {
    updateSelectedModule(menuList, setActionMenuList, setIsAllSelected);
  }, [menuList]);

  const getMenuItemsNumber = (menuKey) => {
    if (menuKey?.categories && menuKey?.categories?.length > 0) {
      const number = menuKey?.categories?.map((category) => {
        const itemsInCategory = category?.items?.length;
        const comboInCategory = category?.combo?.length;
        const itemsInSubCategory = category?.subCategories?.map(
          (subCategory) => subCategory?.items?.length,
        );
        return itemsInCategory + comboInCategory + itemsInSubCategory?.reduce((a, b) => a + b, 0);
      });
      return number?.reduce((a, b) => a + b, 0);
    }
    return null;
  };

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
              <BulkActionCheckBox
                onChange={handleSelectAll}
                checked={isAllSelected || false}
                selectedLength={selectedIRD_MENULength}
                totalLength={inRoomDiningMenu?.length}
                inputProps={{
                  'aria-label': 'select all Menus',
                }}
                className={PARTIAL_CHECKBOX_GREEN}
              />
            </TableCell>
            <TableCell className='w-30'>Name</TableCell>
            <TableCell className='w-15'>Menu Type</TableCell>
            <TableCell className='w-15' align='right'>
              No of Categories
            </TableCell>
            <TableCell className='w-15' align='right'>
              No of Items
            </TableCell>
            <TableCell className='w-15' align='center'>
              Status
            </TableCell>
            <TableCell align='right'></TableCell>
          </TableRow>
        </TableHead>

        <DragDropContext
          onDragEnd={(event) =>
            handleOnDragEnd(event, setVisible, menuList, setMenuList, false, page, rowsPerPage)
          }
          isDropDisabled={dragDisabled}
        >
          <Droppable droppableId='services' isDropDisabled={dragDisabled}>
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {(rowsPerPage > 0
                  ? menuList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : menuList
                ).map((comboKey, key) => (
                  <Draggable
                    key={comboKey.id}
                    draggableId={comboKey.id}
                    index={key}
                    isDragDisabled={dragDisabled}
                  >
                    {(provided) => (
                      <TableRow
                        key={key}
                        className='border-white pointer'
                        onClick={(e) => {
                          onClickRowViewDetails(comboKey, e);
                        }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <TableCell className='w-12'>
                          {!dragDisabled && (
                            <span style={{ marginRight: 1.5 }}>
                              <DragIndicator className='res-menu-accordion-drag' />
                            </span>
                          )}
                          <Checkbox
                            onChange={(event) => handleCheckboxChange(comboKey?.id)}
                            checked={comboKey?.isChecked || false}
                            inputProps={{
                              'aria-label': `select notification ${comboKey?.id}`,
                            }}
                          />
                        </TableCell>
                        <TableCell className='w-30'>{comboKey?.name}</TableCell>
                        <TableCell className='w-15'>{comboKey?.menuType || '--'}</TableCell>
                        <TableCell className='w-15' align='right'>
                          {comboKey?.categories?.length || '--'}
                        </TableCell>
                        <TableCell className='w-15' align='right'>
                          {comboKey?.menuURL ? '--' : getMenuItemsNumber(comboKey) || '--'}
                        </TableCell>
                        <TableCell className='w-15' align='center'>
                          <CustomChip
                            label={comboKey?.isActive ? 'Published' : 'Draft'}
                            color={comboKey?.isActive ? 'primary' : 'default'}
                          />
                        </TableCell>
                        <TableCell align='right'>
                          {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                            RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, comboKey);
                              }}
                              className='showpopupInner'
                            >
                              <MoreHoriz className='showpopupInner' />
                            </Button>
                          )}
                          <Menu
                            id={key}
                            anchorEl={selectedValue?.anchorEl}
                            disableRestoreFocus
                            MenuListProps={{ autoFocusItem: false }}
                            keepMounted
                            open={
                              Boolean(selectedValue.anchorEl) && selectedValue.id === comboKey.id
                            }
                            onClose={handleClose}
                            className='shadow'
                          >
                            <MenuItem
                              className='pe-4'
                              onClick={(e) =>
                                onActiveDeActiveMenuItem(
                                  e,
                                  comboKey?.isActive ? 'deactivate' : 'active',
                                )
                              }
                            >
                              {comboKey?.isActive ? (
                                <>
                                  <RemoveCircle className='me-2 action-menu-icon' />
                                  Deactivate
                                </>
                              ) : (
                                <>
                                  <AddCircle className='me-2 action-menu-icon' />
                                  Activate
                                </>
                              )}
                            </MenuItem>
                            <MenuItem
                              className='pe-4'
                              onClick={(e) =>
                                (!isEmpty(comboKey?.menuURL) || !isEmpty(comboKey?.images)) &&
                                comboKey?.categories?.length === 0
                                  ? onOpenDrawer(e, IN_ROOM_DINING_MENU_EDIT_DRAWER)
                                  : onClickEditDetails(IN_ROOM_DINING_MENU_CREATE)
                              }
                            >
                              <CreateIcon className='me-2 action-menu-icon' />
                              Edit Menu
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onViewDetails(comboKey)}>
                              <VisibilityIcon className='me-2 action-menu-icon' />
                              View
                            </MenuItem>
                            <MenuItem className='pe-4' onClick={(e) => onClickDeleteMenu(e)}>
                              <DeleteForeverIcon className='me-2 action-menu-icon' />
                              Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={menuList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default InRoomDiningMenuListTable;
